import {Account, useUpdateAccountMutation} from 'api';
import React, {useEffect, useRef, useState} from 'react';

interface Props {
  account: Account;
}

export default ({account}: Props) => {
  const [updateAccount] = useUpdateAccountMutation({
    refetchQueries: ['activitiesByProspectPool'],
  });
  const [corpNumber, setCorpNumber] = useState(account.corpNumber);
  const ref = useRef(null);

  useEffect(() => {
    ref.current.value = account.corpNumber;
  }, [account]);

  return (
    <input
      defaultValue={corpNumber}
      className="w-60 h-7 rounded hover:border hover:border-border focus:border focus:border-border"
      onChange={(e) => setCorpNumber(e.target.value)}
      onBlur={(e) =>
        updateAccount({
          variables: {
            id: account.id,
            attributes: {
              corpNumber: e.target.value,
            },
          },
        })
      }
      ref={ref}
    />
  );
};
